import React from "react";
// import slide1 from "../assets/1.png";
// import slide2 from "../assets/2.png";
import mobile1 from "../assets/RCI-Website-banner---480x60-Pixel-02.jpg";
import mobile2 from "../assets/CC-Website-banner---480x60-Pixel-03.jpg";
import mobile3 from "../assets/CC-Website-banner---480x60-Pixel-04.jpg";
import slide1 from "../assets/RCI-Website-Banner.jpg";
import slide2 from "../assets/CC-Website-Banner-01.jpg";
// import slide3 from "../assets/3.png";
// import slide4 from "../assets/4.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar} from '@fortawesome/free-solid-svg-icons';
import SearchWidget from "./SearchWidget";
import "../style.css" ;


const Header =()=>{
    return(
        <>
        <div className="header">
            <div className="offer-alert">
                <div>
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                </div>
                <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
            </div>



              {/* mobile responsive */}

            <div id="carouselExampleIndicators2" class="carousel slide  mobile-header" data-bs-ride="carousel" data-bs-interval="2000">

{/* <div className="header-image">
 <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer"> <img src={slide3} alt="Royal Caribbean" style={{cursor:'pointer'}}/></a>
 </div> */}
{/* <div class="carousel-indicators">
<button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
<button type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide-to="1" aria-label="Slide 2"></button>
{/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
{/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

{/* </div> */} 
<div class="carousel-inner laptop-responsive">
<div class="carousel-item active ">
<a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer">
<img src={mobile1} class="d-block w-100 " alt="..."/>
</a>
</div>
<div class="carousel-item ">
<a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc" target="_" rel="noopener noreferrer">
<img src={mobile2} class="d-block w-100 " alt="..."/>
</a>
</div>
<div class="carousel-item mobile">
<a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc" target="_" rel="noopener noreferrer">
<img src={mobile3} class="d-block w-100" alt="..."/>
</a>
</div>
{/* <div class="carousel-item mobile">
<img src={mobile2} class="d-block w-100" alt="..."/>
</div> */}
</div>

{/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="prev">
<span class="carousel-control-prev-icon" aria-hidden="true"></span>
<span class="visually-hidden">Previous</span>
</button>
<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators2" data-bs-slide="next">
<span class="carousel-control-next-icon" aria-hidden="true"></span>
<span class="visually-hidden">Next</span>
</button> */}
</div>

            <div class= "ajslider ">
            <div id="carouselExampleIndicators" class="carousel slide ajslider-container laptop-header" data-bs-ride="carousel" data-bs-interval="3000">

           {/* <div className="header-image">
            <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer"> <img src={slide3} alt="Royal Caribbean" style={{cursor:'pointer'}}/></a>
            </div> */}
   <div class="carousel-indicators" >
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button> */}
    {/* <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button> */}

  </div>
  <div class="carousel-inner laptop-responsive">
    <div class="carousel-item active ">
<a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=8&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer">
      <img src={slide1} class="d-block w-100 " alt="..."/>
      </a>
    </div>
    <div class="carousel-item ">
<a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&cruiseline=2&destinationtype=All&sortColumn=cruiselinePriority&sortOrder=asc" target="_" rel="noopener noreferrer">
      <img src={slide2} class="d-block w-100 " alt="..."/>
      </a>
    </div>
    {/* <div class="carousel-item mobile">
      <img src={mobile1} class="d-block w-100" alt="..."/>
    </div>
    <div class="carousel-item mobile">
      <img src={mobile2} class="d-block w-100" alt="..."/>
    </div> */}
  </div>

 
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
  </div>


  <div className="SearchCruise">
    <h2>Search For Cruise</h2>
    <SearchWidget/>
  </div>

</div>

        </div>
        
        </>
    );
}

export default Header;